var _effectorFileName = "/builds/gmini/front-ui-kit/src/ExplorerLayout/ExplorerLayout.styled.ts";
import { styled as mStyled } from '@mui/material';
import styled from 'styled-components';
import { Paper } from '../Paper';
import bgUrl from './bg.png';
export const ExplorerBody = styled(Paper)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: auto;
  flex-grow: 1;
`;
export const BodyContainer = mStyled('div')(props => ({
  width: `${(props.panelWidth + 10) * props.count}px`,
  minWidth: '900px',
  maxWidth: '100%',
  display: 'flex',
  margin: 'auto',
  flexDirection: 'column',
  height: '100%',
  paddingBottom: '30px',
  paddingTop: '20px'
}));
export const ExplorerContainer = styled.div`
  height: 100vh;
  width: 100%;
  background-color: #080b45;
  background-image: url(${bgUrl});
  background-repeat: no-repeat;
  background-position: bottom center;
  display: flex;
  justify-content: center;
`;
export const ExplorerLayoutHeader = styled.div`
  display: flex;
  width: 100%;
  padding: 15px 20px;
  justify-content: space-between;
`;
export const BottomBrandName = styled.div`
  margin-left: 3px;
  color: #080b45;
  font-size: 20px;
  font-weight: 800;
`;
export const BottomBrandWrap = styled.div`
  background-color: #56587c;
  padding: 6px;
  padding-right: 10px;
  margin-right: 10px;
  height: 46px;
  display: flex;
  align-items: center;
  border-radius: 5px;
`;
export const Footer = styled.div`
  display: flex;
  align-items: center;
  margin: auto;
  padding-top: 20px;
`;
export const FooterText = styled.div`
  color: #7c7e98;
`;
export const HeaderLeftSideWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;
export const Separator = styled.div`
  background: #353b60;
  width: 1px;
  height: 36px;
  opacity: 0.2;
  margin: 8px 6px;
`;